import React from 'react';
import PropTypes from 'prop-types';

import ErrorWrapper from 'dpl/form/components/ErrorWrapper';
import FullPageQuizTextInput from 'dpl/components/FullPageQuiz/FullPageQuizTextInput';
import FullPageQuizQuestion from 'dpl/components/FullPageQuiz/FullPageQuizQuestion';

const INPUT_NAME = 'lifestyle_description';

export default function QuizLifestyleQuestion({
  formErrors,
  formState,
  handleNextClick,
  onChange,
  isValid,
  breederName
}) {
  const lifestyleDescription = formState[INPUT_NAME] || '';
  const errors = formErrors[INPUT_NAME];

  return (
    <div className="AdoptionApplicationQuizLifestyleQuestion">
      <FullPageQuizQuestion
        handleNextClick={handleNextClick}
        isValid={isValid}
        title={`Tell ${breederName} about yourself`}
        subtitle={`Share a little bit about how you like to spend your time, your work schedule, family members, activity level, and anything else you want ${breederName} to know about you. `}
      >
        <ErrorWrapper errors={errors}>
          <FullPageQuizTextInput
            Tag="textarea"
            name={INPUT_NAME}
            onChange={onChange}
            value={lifestyleDescription}
            placeholder="e.g. We are a family of 5. My oldest son is away at college and we have two teenagers here in the home. We enjoyed working with a nearby trainer for our dog Cooper and plan on doing the same with the new puppy. We have a large home and a spacious yard."
          />
        </ErrorWrapper>
      </FullPageQuizQuestion>
    </div>
  );
}

QuizLifestyleQuestion.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  formErrors: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  formState: PropTypes.object.isRequired,
  handleNextClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired,
  breederName: PropTypes.string.isRequired
};
